import { FaWhatsapp } from 'react-icons/fa';
import { useAdvisors } from '../context/useAdvisorsContext';

const AdvisorsSection = () => {
  const { data: advisors, isLoading, error } = useAdvisors();

  if (isLoading) {
    return (
      <section className="bg-green-light-cu py-5">
        <div className="container text-center">
          <h2 className="advisors-section-title mb-5">Nuestros Asesores</h2>
          <p className="text-green">Cargando asesores...</p>
        </div>
      </section>
    );
  }

  if (error || !advisors || advisors.length === 0) {
    return null;
  }

  return (
    <section className="bg-green-light-cu py-5">
      <div className="container">
        <h2 className="advisors-section-title mb-5">Nuestros Asesores</h2>
        <div className="d-flex flex-column gap-5">
          {advisors.map((advisor) => (
            <AdvisorCard key={advisor.id} advisor={advisor} />
          ))}
        </div>
      </div>
    </section>
  );
};

const AdvisorCard = ({ advisor }) => {
  const firstName = advisor.name?.split(' ')[0] || advisor.name;
  const whatsappUrl = `https://wa.me/${advisor.whatsapp?.replace(/[^0-9]/g, '')}`;

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="advisor-cards-container d-flex flex-column flex-md-row gap-3 w-100" style={{ maxWidth: '900px' }}>
        {/* Image card */}
        <div className="advisor-image-card">
          <img
            src={advisor.photoUrl}
            alt={advisor.name}
            className="advisor-photo"
          />
        </div>

        {/* Info card */}
        <div className="advisor-info-card d-flex flex-column justify-content-center p-4">
          <div className="d-flex align-items-center gap-2 mb-1">
            <h3 className="advisor-name mb-0">{advisor.name}</h3>
            <img src="/images/check-mark.png" alt="Verificada" width="28" height="28" />
          </div>
          <p className="advisor-verified-text mb-3">
            Asesora verificada <span className="fw-semibold">Carros a Centro America</span>
          </p>
          <p className="advisor-description mb-0">
            {advisor.description_es}
          </p>
        </div>
      </div>

      {/* Tags */}
      {advisor.tags && advisor.tags.length > 0 && (
        <div className="d-flex flex-wrap justify-content-center gap-2 mt-3" style={{ maxWidth: '900px' }}>
          {advisor.tags.map((tag, index) => (
            <span
              key={index}
              className={index === 0 ? 'advisor-tag-primary' : 'advisor-tag-secondary'}
            >
              {tag.name_es}
            </span>
          ))}
        </div>
      )}

      {/* WhatsApp button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="advisor-whatsapp-btn mt-3"
      >
        Hablar con {firstName} ahora <FaWhatsapp size={20} />
      </a>
    </div>
  );
};

export default AdvisorsSection;
